import { Timestamp } from "firebase-admin/firestore";

export const convertDate = (timestamp: Timestamp) => {
  if (!timestamp) return "";
  const dt = timestamp.toDate();
  const y = dt.getFullYear();
  const m = dt.getMonth() + 1;
  const d = dt.getDate();
  return `${y}年${m}月${d}日`;
};

export const setFocus = ({
  currentTarget: { lastChild },
}: {
  currentTarget: { lastChild: any };
}) => lastChild && lastChild.focus();

export const getOgiUrl = (
  title: string,
  thumb: string,
  authorName: string,
  color: string
) => {
  const thumbOpt = {
    font: "l_text:twemoji.woff2",
    size: "_440:",
    width: ",w_600,",
    position: "g_north_east,x_35,y_30,",
    body: encodeURIComponent(encodeURIComponent(thumb)),
    opt: "c_fit,o_20,a_12",
  };
  const ogiThumb = `${thumbOpt.font}${thumbOpt.size}${thumbOpt.body}${thumbOpt.width}${thumbOpt.position}${thumbOpt.opt}`;
  const titleOpt = {
    font: "l_text:NotoSansJP.otf",
    color: ",co_rgb:1b1b1b,",
    size: "_72:",
    width: "w_1100,",
    position: "x_20,y_-100,",
    body: encodeURIComponent(title),
    opt: "c_fit",
  };
  const ogiTitle = `${titleOpt.font}${titleOpt.size}${titleOpt.body}${titleOpt.color}${titleOpt.width}${titleOpt.position}${titleOpt.opt}`;
  const authorOpt = {
    font: "l_text:NotoSansJP.otf",
    color: ",co_rgb:1b1b1b,",
    size: "_64:",
    width: "w_700,",
    position: "g_south_west,x_90,y_30,",
    body: encodeURIComponent(authorName),
    opt: "c_fit",
  };
  const ogiAuthor = `${authorOpt.font}${authorOpt.size}@${authorOpt.body}${authorOpt.color}${authorOpt.width}${authorOpt.position}${authorOpt.opt}`;
  const borderOpt = {
    size: "w_60,h_630,",
    position: "g_north_west,x_0,y_0,",
    color: `e_colorize,co_rgb:${color.replace(/#/g, "")},`,
  };
  const ogiBorder = `l_pixel.jpg,${borderOpt.size}${borderOpt.position},${borderOpt.color}`;
  return `https://res.cloudinary.com/boitorea/image/upload/${ogiThumb}/${ogiTitle}/${ogiAuthor}/${ogiBorder}/v1635466657/ogi_b.jpg`;
};

export const shuffle = (array: string[]) => {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

export const alertError = (err: any) => {
  console.log(err);
  err && err instanceof Error && err.message && alert(err.message);
};
